import {createSlice} from '@reduxjs/toolkit'
import Sheet from "../../utils/sheet";
import SheetTemplate from "../../utils/sheetTemplate";
import History from "../../utils/history";

const sheetSlice = createSlice({
    name: 'availableSheets',
    initialState: {
        sheets: [
            new Sheet({}, {isStartingSheet: true}, 1.0, new SheetTemplate({height: 12, width: 18 }, 0), '')
        ],
        userName: ''
    },
    reducers: {
        setSheetList: (state, action) => {
            state.sheets = action.payload
        },
        addNewSheet: (state, action) => {
            let {
                currentSheetList,
                newSheet,
                index,
            } = action.payload;

            state.sheets = [
                ...currentSheetList.slice(0, index),
                newSheet,
                ...currentSheetList.slice(index)
            ];
        },
        updateSheetObjects: (state, action) => {
            let {
                sheetId,
                objectList
            } = action.payload;

            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.objects = objectList;
                }
            });

            state.sheets = tempSheets;
        },
        updateSheetSize: (state, action) => {
            let {
                sheetId,
                height,width
            } = action.payload;

            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.size ={height,width}
                }
            });

            state.sheets = tempSheets;
        },
        updateSheetBackgroundColor: (state, action) => {
            let {
                sheetId,
                backgroundColor
            } = action.payload;
            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.backgroundColor = backgroundColor;
                }
            });

            state.sheets = tempSheets;
        },
        updateSheetBackgroundImage: (state, action) => {
            let {
                sheetId,
                backgroundImage
            } = action.payload;
            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.backgroundImage = backgroundImage;
                }
            });

            state.sheets = tempSheets;
        },
        updateSheetZoom: (state, action) => {
            let {
                sheetId,
                zoomValue
            } = action.payload;
            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.zoom = zoomValue;
                }
            });

            state.sheets = tempSheets;
        },
        updateSheetThumbnail: (state, action) => {
            let {
                sheetId,
                thumbnail
            } = action.payload
            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    sheet.thumbnail = thumbnail;
                }
            });

            state.sheets = tempSheets;
        },
        deleteSheet: (state, action) => {
            let {
                sheetIndex
            } = action.payload;
            let tempSheets = [...state.sheets];
            tempSheets.splice(sheetIndex, 1);
            state.sheets = tempSheets;
        },
        updateSheetHistory: (state, action) => {
            let {
                sheetId,
                objectState
            } = action.payload

            let tempSheets = [...state.sheets];

            tempSheets.forEach(sheet => {
                if (sheet.id === sheetId) {
                    if(sheet.history === undefined) {
                        sheet.setSheetHistory(new History())
                    }
                    sheet.history.addInUndoList(objectState);
                }
            });
            state.sheets = tempSheets;
        },
    }
})
export const {setSheetList, addNewSheet, updateSheetObjects, deleteSheet, updateSheetBackgroundImage, updateSheetZoom,updateSheetSize, updateSheetThumbnail, updateSheetListDetailVisibility, updateSheetOverlapStatus,updateSheetListDetailName, updateSheetHistory, updateSheetDPIStatus, updateSheetSpaceStatus} = sheetSlice.actions;
export default sheetSlice.reducer;
